const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Cześć',
    'Ref: Page content body':
      'W dniu przyjazdu i wyjazdu proszę pamiętać o zeskanowaniu swojego QR Code Bus',
  },
};
export default labels;
